import { cx } from '../cx';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  label?: string;
}

const sizes = { sm: 'h-4 w-4 border-2', md: 'h-6 w-6 border-2', lg: 'h-9 w-9 border-[3px]' };

export function Spinner({ size = 'md', className, label }: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label={label ?? 'Loading'}
      className={cx(
        'inline-block animate-spin rounded-full border-current border-r-transparent align-[-0.125em]',
        sizes[size],
        className,
      )}
    />
  );
}

/** Full-area spinner for lazy routes and first loads. */
export function LoadingBlock({ label }: { label?: string }) {
  return (
    <div className="flex min-h-40 w-full items-center justify-center text-fg-subtle">
      <Spinner label={label} />
    </div>
  );
}
